export default (theme) => ({
    root: {
        textDecoration: 'none',
        fontWeight: 'bold',
    },
});
